import { useNavigate } from "react-router-dom";
import { Send } from "lucide-react";
import { Button } from "@/design-system/components/ui";
import { useAuth } from "@/hooks/useAuth";
import type { OwnerEntityType } from "@/components/Collection/OwnerPicker";

// External Intake & Collection v1.0 PR 8 (Series 1) — entry-point
// affordance dropped into Deal / Person / Entity / Business detail
// headers. Routes to /collection/packages/new with the owner pre-filled
// via query params so staff land on the wizard ready to pick a recipient.
// Hidden for users without Collection.ManagePackages.

interface Props {
  ownerEntityType: OwnerEntityType;
  ownerEntityId: string;
  ownerDisplayName: string;
  variant?: "primary" | "secondary";
  size?: "sm" | "md";
}

export function RequestDocumentsButton({
  ownerEntityType,
  ownerEntityId,
  ownerDisplayName,
  variant = "secondary",
  size = "md",
}: Props) {
  const navigate = useNavigate();
  const { hasPermission } = useAuth();
  if (!hasPermission("Collection.ManagePackages")) return null;

  function go() {
    const params = new URLSearchParams({
      ownerEntityType,
      ownerEntityId,
      ownerDisplayName,
    });
    navigate(`/collection/packages/new?${params.toString()}`);
  }

  return (
    <Button type="button" variant={variant} size={size} onClick={go}>
      <Send size={14} aria-hidden />
      Request documents
    </Button>
  );
}
